import { computed, inject } from 'vue'
import type { ComputedRef } from 'vue'

/**
 * Only use this for vue composition API setup functions.
 * Because inject() can only be used inside setup() or functional components.
 * For vue options API, use `this.$isFeatureEnabled` instead.
 *
 * Throws when the feature-flags plugin has not provided `isFeatureEnabled`.
 */
export function useFeatureFlag(flag: string): ComputedRef<boolean> {
  const isFeatureEnabled = inject<(flag: string) => boolean>('isFeatureEnabled')

  if (!isFeatureEnabled) {
    throw new Error(
      `isFeatureEnabled not provided, cannot check feature flag "${flag}"`
    )
  }

  return computed(() => isFeatureEnabled(flag))
}
